import React from 'react';
import PropTypes from 'prop-types';
import { CloseIcon } from 'components';

import './connection-error.scss';

export function ConnectionError(props) {
  const { containerClassName, circleStyle, circleInnerStyle, children } = props;

  return (
    <div className={`connection-error-page ${containerClassName}`}>
      <div className="connection-error-page__content flex align-items-center justify-content-center flex-column">
        <div className="connection-error-page__circle-container">
          <div
            className="connection-error-page__circle flex justify-content-center align-items-center"
            style={circleStyle}
          >
            <div
              className="connection-error-page__inner-circle flex justify-content-center align-items-center"
              style={circleInnerStyle}
            >
              <CloseIcon className="fill-persian-red connection-error-page__icon" />
            </div>
          </div>
        </div>

        {children}
      </div>
    </div>
  );
}

ConnectionError.propTypes = {
  containerClassName: PropTypes.string,
  circleStyle: PropTypes.object,
  circleInnerStyle: PropTypes.object,
  children: PropTypes.node,
};

ConnectionError.defaultProps = {
  containerClassName: 'p-8',
  circleStyle: {},
  circleInnerStyle: {},
};
